<template>
  <layout>
    <page-header
      :actions="actions"
      :header="$t('settings.sections.contract_templates')"
    />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps">
        <template #url="{ item }">
          <a :href="item.url" target="_blank">{{ $t('general.download') }}</a>
        </template>
      </admin-table>
    </div>
    <contract-template-form-modal @saved="$refs.table.refresh()" />
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import Api from './Api'
import ContractTemplateFormModal from './ContractTemplateFormModal'

const resourceBase = 'company-applications'

export default {
  name: 'CompanyContracts',

  components: {
    AdminTable,
    ContractTemplateFormModal,
  },

  data() {
    return {
      res: 0,
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new Api()
        },
        sortBy: 'uploaded_at',
        sortDesc: true,
        perPage: 10,
        columns: [
          {
            key: 'id',
            label: this.$t('general.id'),
            sortable: true,
          },
          {
            key: 'is_default',
            label: this.$t('general.default'),
            formatter: value => {
              return value ? this.$t('general.yes') : ''
            },
          },
          {
            key: 'lang',
            label: this.$t('attributes.contact_name'),
            sortable: true,
          },
          {
            key: 'uploaded_at',
            label: this.$t('attributes.uploaded_at'),
            sortable: true,
            component: 'value-date',
          },
          {
            key: 'url',
            label: '',
          },
        ],
        // eslint-disable-next-line no-unused-vars
        rowActions: () => {
          const actions = []
          if (this.$allows('administer')) {
            actions.push('delete')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },

  computed: {
    actions() {
      if (this.$allows(`administer`)) {
        return [
          {
            id: 'create',
            text: this.$t('general.add_new'),
            icon: 'icon-plus-circle2',
            onClick: () => {
              this.$bvModal.show('contract-template-form-modal')
            },
          },
        ]
      } else {
        return []
      }
    },
  },
}
</script>
